import React, { useLayoutEffect } from "react"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { fetchUserCreditionals } from "redux/modules/userDatas/actions"
import { fetchData } from "redux/modules/application/actions"
import MainRoutes from "routes/routes"
export default () => {
  const { i18n } = useTranslation()
  const dispatch = useDispatch()
  const defaultLang = localStorage?.getItem("lang")
  const token = localStorage?.getItem("mmbs_access_token")

  if (!defaultLang) {
    localStorage.setItem("lang", "uz")
  }
  useLayoutEffect(() => {
    dispatch(fetchData())
    i18n.changeLanguage(defaultLang)
  }, [])

  useEffect(() => {
    if (token) {
      dispatch(fetchUserCreditionals())
    }
  }, [token])
  return (
    <>
      <MainRoutes />
    </>
  )
}
